import React from 'react';
import './AmenitiesCon.css'
const AmenitiesCon = (props) => {
    return ( <>
         <div className={props.s3}>
            <div className="row2">
            <img src={props.icons} alt='/'/><div>{props.text}</div> 
            </div>
        </div>
    </> );
}
 
export default AmenitiesCon;